export const apiServer = 'http://famimedical.com';


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Services/Api/Config/index.tsx